import { useEffect } from "react";

import {
  CategoryName,
  ModuleName,
  PageRoute,
  QueryParam
} from "../../../../models/enums";

import { getUrlParams } from "../../../../services/utils";

const preselectedCategory = CategoryName.housesForSale;

export const useInitialSearch = (props, handleSearch, queryParams) => {
  useEffect(() => {
    const {
      module,
      location: { search, pathname }
    } = props;

    const query = getUrlParams(search, QueryParam.searchQuery);
    if (!query && module == ModuleName.realEstate) {
      queryParams.current = {
        ...queryParams.current,
        category: preselectedCategory
      };
    } else {
      queryParams.current = query
        ? { ...query, ...queryParams.current }
        : queryParams.current;
    }

    // Skip search after navigate from ad details to all search page (store hasn't update curent module to empty jet)
    if (module && !pathname.includes(module)) {
      return;
    }

    // Skip search after navigate to module search (the init module is empty and then change to module name)
    if (!module && pathname.indexOf(PageRoute.search) !== 0) {
      return;
    }

    handleSearch();
  }, []);

  return () => {
    props.clearAdsSearchResults();
  };

}


// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/hooks/useInitialSearch.ts